/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_UnrankedInputs */



/**
* | output |
* | --- |
* | "unranked events are not archived" |
*
* @param {Twda_Reason_UnrankedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_unranked = /** @type {((inputs?: Twda_Reason_UnrankedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_UnrankedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("les événements non classés ne sont pas archivés")
	if (locale === "es") return /** @type {LocalizedString} */ ("los eventos no clasificados no se archivan")
	if (locale === "pt") return /** @type {LocalizedString} */ ("eventos não classificados não são arquivados")
	if (locale === "it") return /** @type {LocalizedString} */ ("gli eventi non classificati non vengono archiviati")
	return /** @type {LocalizedString} */ ("unranked events are not archived")
});